import { useQuery } from "@tanstack/react-query";
import { showcaseClient } from "@/integrations/supabase/showcase-client";

export const useDeviceViewCount = (deviceId: string) => {
  return useQuery({
    queryKey: ['device-view-count', deviceId],
    queryFn: async () => {
      const { count, error } = await showcaseClient
        .from('device_public_views')
        .select('*', { count: 'exact', head: true })
        .eq('device_id', deviceId);

      if (error) throw error;
      return count || 0;
    },
    enabled: !!deviceId,
    staleTime: 60 * 1000, // Cache for 1 minute
  });
};
